import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState
} from 'react'

import {
  Botao,
  Cores,
  IconeRevelarSenha,
  ModalBase,
  ModalBaseProps,
  ModalRef,
  Tabela,
  TabelaDados,
  TabelaRef,
  TabelaResposta,
  Tooltip
} from 'src/componentes'
import { Api } from 'src/servicos'
import { Documento, TipoOrdenacao } from 'src/tipos'

import {
  ContainerAcoes,
  ContainerDosBotoes,
  ContainerTabela,
  CorpoModal,
  IconeAcao,
  TituloPrincipal
} from '../style'

export interface ModalRealizarDownloadRef extends Omit<ModalRef, 'abrir'> {
  abrir: (item: any) => void
}

const ModalVisualizacaoComponent: React.ForwardRefRenderFunction<
  ModalRealizarDownloadRef,
  ModalBaseProps
> = ({ backdrop }, ref) => {
  const [aberta, definirAberta] = useState(false)
  const tabelaRefPdf = useRef<TabelaRef>()
  const [requerimentoId, defirRequerimentoId] = useState('')
  const [carregandoPDF, definirCarregandoPDF] = useState<boolean>(false)

  const abrir = (item: any) => {
    defirRequerimentoId(item)
    definirAberta(true)
  }

  const fechar = () => {
    definirAberta(false)
  }

  useImperativeHandle<ModalRealizarDownloadRef, ModalRealizarDownloadRef>(
    ref,
    () => ({
      fechar,
      abrir
    })
  )

  const obterDadosDois = async (
    numeroPaginas: number,
    quantidadePorPagina: number,
    chaveOrdenacao?: string,
    ordem?: TipoOrdenacao
  ): Promise<TabelaResposta | null> => {
    if (requerimentoId?.length > 0) {
      const dados = await Api.ObterInformacaoTicketEmenta(requerimentoId)
      if (!dados) return null
      return {
        Dados: dados?.itens
      } as TabelaResposta
    }
  }

  const abrirImagemNovaAba = (
    documentoAluno: Documento,
    nomeDisciplina: string
  ) => {
    const novaAba = window.open('')
    if (documentoAluno.contentType === 'application/pdf') {
      novaAba.document.write(
        `<iframe width='100%' height='100%' src='data:${documentoAluno?.contentType};base64, ` +
          encodeURI(documentoAluno?.base64) +
          "' />"
      )
    } else {
      const img = `<img src='${`data:${documentoAluno?.contentType};base64, ${documentoAluno?.base64}`}' />`
      novaAba.document.write(img)
    }
    novaAba.document.title = `Disciplina: ${nomeDisciplina}`
  }

  const visualizarDocumento = async (
    documentoId: string,
    nomeDisciplina: string
  ) => {
    try {
      const novoDocumento = await Api.RequisitarDocumentoEmenta(
        requerimentoId,
        documentoId
      )

      if (novoDocumento) {
        abrirImagemNovaAba(novoDocumento, nomeDisciplina)
      }
    } catch (error) {}
  }

  const visualizacao = async (documentoId: string, nomeDisciplina: string) => {
    try {
      definirCarregandoPDF(true)
      await visualizarDocumento(documentoId, nomeDisciplina)
    } finally {
      definirCarregandoPDF(false)
    }
  }

  useEffect(() => {
    tabelaRefPdf.current.CarregarDados()
  }, [requerimentoId])

  return (
    <ModalBase id="modal-download-arquivo" backdrop={backdrop} aberta={aberta}>
      <CorpoModal>
        <TituloPrincipal style={{ marginBottom: '20px' }}>
          Visualizar Anexo Ementa
        </TituloPrincipal>
        <ContainerTabela>
          <Tabela
            ref={tabelaRefPdf}
            Colunas={[
              {
                Chave: 'nomeDisciplina',
                Renderizar: (linha: TabelaDados) => (
                  <span>{linha.nomeDisciplina}</span>
                ),
                RenderizarCabecalho: () => (
                  <div style={{ width: 200 }}>Disciplina</div>
                )
              },
              {
                Chave: 'arquivoEmenta',
                Renderizar: (linha: TabelaDados) => (
                  <span>{linha?.arquivoEmenta}</span>
                ),
                RenderizarCabecalho: () => (
                  <div style={{ width: 150 }}>Anexo</div>
                )
              },
              {
                Chave: 'acoes',
                Alinhamento: 'center',
                RenderizarCabecalho: () => <div>Ação</div>,

                Renderizar: (linha: TabelaDados) => {
                  return (
                    <ContainerAcoes>
                      <IconeAcao
                        onClick={() => {
                          if (linha?.arquivoEmenta !== null) {
                            visualizacao(
                              linha?.copiaEmentaDisciplinasSolicitadasId,
                              linha?.nomeDisciplina
                            )
                          }
                        }}
                        disabled={
                          linha?.arquivoEmenta === null || carregandoPDF
                        }
                        data-tip={
                          linha?.arquivoEmenta === null
                            ? 'Não há documento para ser visualizado.'
                            : 'Visualizar Documento'
                        }
                        data-for={'icone-visualizar-documento'}
                      >
                        {IconeRevelarSenha}
                        <Tooltip
                          id={'icone-visualizar-documento'}
                          textColor={Cores.PRETO}
                          backgroundColor={Cores.CINZA_1_CLARO}
                          place="bottom"
                        />
                      </IconeAcao>
                    </ContainerAcoes>
                  )
                }
              }
            ]}
            ObterDados={obterDadosDois}
          />
        </ContainerTabela>
        <ContainerDosBotoes>
          <Botao onClick={fechar} texto="Fechar" />
        </ContainerDosBotoes>
      </CorpoModal>
    </ModalBase>
  )
}

export const ModalRealizarDownload = forwardRef(ModalVisualizacaoComponent)
